var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItineraryFolded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "transparent",
    d: "M3.3 20.227a.43.43 0 0 1-.3-.4V3.092a.42.42 0 0 1 .176-.337.43.43 0 0 1 .384-.063l5.423 1.693V22zM9.705 4.3l5.128-2.261v17.656l-5.128 2.266zm11.277 17.008-5.427-1.7V2l5.688 1.773a.42.42 0 0 1 .3.4V20.9a.43.43 0 0 1-.171.341.44.44 0 0 1-.257.08.5.5 0 0 1-.133-.013z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItineraryFolded);
export default __webpack_public_path__ + "static/media/itineraryFolded.8b7d737e6c31a5fa1a37d8775b0c6f99.svg";
export { ForwardRef as ReactComponent };